import * as React from 'react';
import { StyleProp, View, ViewStyle, Text, StyleSheet } from 'react-native';
import Svg, { G, Path } from 'react-native-svg';

const RibbonBadge = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
    number?: number;
    numberFontSize?: number;
    topNumberPos?: string | number;
  }) => {
    const {
      width = 63,
      height = 88,
      containerStyle,
      number,
      numberFontSize = 26,
      topNumberPos = 15,
    } = props;

    return (
      <View style={[{ width, height }, containerStyle]}>
        {/* SVG badge */}
        <Svg width="100%" height="100%" viewBox="0 0 63 88" fill="none">
          {/* --- Ribbons --- */}
          <Path
            d="M26.8105 55.4836L36.184 87.6575L43.8834 76.3624L56.605 81.1548L46.5619 50.0078L26.8105 55.4836Z"
            fill="#CD3414"
          />
          <G opacity="0.7">
            <Path
              d="M32.0923 64.4532L31.1035 64.7617L37.3703 85.7584L38.3591 85.4499L32.0923 64.4532Z"
              fill="#FFCE45"
            />
          </G>
          <G opacity="0.7">
            <Path
              d="M46.3864 54.9792L45.4004 55.2969L53.1011 80.283L54.0871 79.9653L46.3864 54.9792Z"
              fill="#FFCE45"
            />
          </G>
          <Path
            d="M15.4298 52.0625L5.38672 81.8402L19.1127 77.049L26.1425 88.0019L37.8596 56.1703L15.4298 52.0625Z"
            fill="#FE5629"
          />
          <G opacity="0.7">
            <Path
              d="M17.9603 50.8822L8.58398 80.3164L9.56696 80.6437L18.9432 51.2095L17.9603 50.8822Z"
              fill="#FFCE45"
            />
          </G>
          <G opacity="0.7">
            <Path
              d="M34.7003 54.2873L23.9844 85.4336L24.9596 85.7843L35.6755 54.6381L34.7003 54.2873Z"
              fill="#FFCE45"
            />
          </G>

          {/* --- Badge Circle --- */}
          <Path
            d="M0.700395 31.183C0.700395 29.7441 4.13071 28.5707 4.32454 27.1858C4.5219 25.7673 1.55445 23.6569 1.94095 22.3105C2.33449 20.9401 5.94925 20.8031 6.52253 19.5228C7.10169 18.228 4.84026 15.3441 5.58742 14.1562C6.33927 12.9611 9.84477 13.874 10.7529 12.8038C11.6621 11.7324 10.283 8.31409 11.3308 7.38443C12.3764 6.45718 15.4907 8.33691 16.6596 7.567C17.8214 6.8019 17.4361 3.12533 18.7025 2.53199C19.9548 1.94585 22.423 4.64712 23.7634 4.24476C25.0815 3.84959 25.7299 0.211459 27.1185 0.00847273C28.473 -0.188508 30.093 3.11452 31.5004 3.11452C32.9078 3.11452 34.5278 -0.186106 35.8811 0.0108749C37.2685 0.21266 37.9181 3.852 39.2362 4.24716C40.5766 4.64953 43.0448 1.94825 44.2971 2.53439C45.5635 3.12653 45.1794 6.8043 46.34 7.5694C47.5089 8.33811 50.622 6.45959 51.6688 7.38684C52.7167 8.31649 51.3375 11.7348 52.2468 12.8062C53.1537 13.8752 56.6592 12.9635 57.4122 14.1586C58.1605 15.3465 55.8979 18.2292 56.4771 19.5252C57.0504 20.8055 60.6651 20.9425 61.0587 22.3129C61.4452 23.6606 58.4777 25.7697 58.6751 27.1882C58.8677 28.5731 62.2992 29.7465 62.2992 31.1854C62.2992 32.6244 58.8689 33.7978 58.6751 35.1827C58.4777 36.6012 61.4452 38.7115 61.0587 40.058C60.6651 41.4284 57.0504 41.5654 56.4771 42.8457C55.8979 44.1405 58.1593 47.0244 57.4122 48.2123C56.6603 49.4073 53.1548 48.4945 52.2468 49.5647C51.3375 50.6361 52.7167 54.0544 51.6688 54.9841C50.6232 55.9113 47.5089 54.0316 46.34 54.8015C45.1782 55.5666 45.5635 59.2432 44.2971 59.8365C43.0448 60.4226 40.5766 57.7214 39.2362 58.1237C37.9181 58.5189 37.2697 62.157 35.8811 62.36C34.5266 62.557 32.9066 59.254 31.4992 59.254C30.0918 59.254 28.4718 62.557 27.1173 62.36C25.7299 62.1582 25.0803 58.5189 23.7622 58.1237C22.4218 57.7214 19.9536 60.4226 18.7013 59.8365C17.4349 59.2444 17.8191 55.5666 16.6584 54.8015C15.4895 54.0328 12.3764 55.9113 11.3297 54.9841C10.2818 54.0544 11.661 50.6361 10.7517 49.5647C9.84477 48.4957 6.33926 49.4073 5.58624 48.2123C4.83791 47.0244 7.10051 44.1417 6.52136 42.8457C5.94807 41.5654 2.33332 41.4284 1.93977 40.058C1.55327 38.7103 4.52073 36.6012 4.32337 35.1827C4.13071 33.7978 0.699219 32.6244 0.699219 31.1854L0.700395 31.183Z"
            fill="#FCAB28"
          />
          <Path
            d="M31.502 56.5092C45.184 56.5092 56.2754 45.1691 56.2754 31.1804C56.2754 17.1917 45.184 5.85156 31.502 5.85156C17.82 5.85156 6.72852 17.1917 6.72852 31.1804C6.72852 45.1691 17.82 56.5092 31.502 56.5092Z"
            fill="#FFCE45"
          />
        </Svg>

        {/* Number overlay */}
        {number !== undefined && (
          <Text style={[styles.number, { fontSize: numberFontSize, top: topNumberPos }]}>
            {number}
          </Text>
        )}
      </View>
    );
  },
);

const styles = StyleSheet.create({
  number: {
    position: 'absolute',
    left: 0,
    right: 0,
    textAlign: 'center',
    fontWeight: '400',
    color: '#000000',
    fontFamily: 'Secular One',
  },
});

export { RibbonBadge };
